import { useState } from 'react';
import { sourceColors, segmentColors, type Lead } from '../../../mocks/leads';

interface PotansiyelBasvurularProps {
  leads: Lead[];
  onViewDetail: (lead: Lead) => void;
}

export default function PotansiyelBasvurular({ leads, onViewDetail }: PotansiyelBasvurularProps) {
  const [sentIds, setSentIds] = useState<Set<string>>(new Set());
  const [search, setSearch] = useState('');

  const filteredLeads = leads
    .filter((l) => !(l.lansmanKatilim === true || l.lansman_katilim_durumu === 'Katılmak İstiyor' || l.lansman_katilim_durumu === 'Katılacak' || l.lansman_katilim_durumu === 'Davet Gönderildi'))
    .filter((l) =>
      search
        ? l.ad_soyad.toLowerCase().includes(search.toLowerCase()) || l.telefon.includes(search)
        : true
    );

  function sendInvite(lead: Lead) {
    setSentIds((prev) => new Set([...prev, lead.id]));
    const phone = lead.telefon.replace(/\D/g, '');
    const msg = encodeURIComponent(
      `Merhaba ${lead.ad_soyad}, franchise lansmanımıza sizi de davet etmek istedik. Katılmak ister misiniz?`
    );
    window.open(`https://wa.me/${phone}?text=${msg}`, '_blank');
  }

  return (
    <div className="space-y-5">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-xl font-bold text-white">Potansiyel Başvurular</h1>
          <p className="text-white/30 text-sm mt-0.5">
            {filteredLeads.length} kişi henüz katılım talebi oluşturmadı
          </p>
        </div>
        <span className="text-xs text-amber-400 font-semibold px-3 py-1.5 rounded-full bg-amber-500/10 border border-amber-500/20 whitespace-nowrap">
          <i className="ri-user-search-line mr-1" />
          {filteredLeads.length} Potansiyel
        </span>
      </div>

      <div className="relative max-w-sm">
        <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-white/30 text-sm" />
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="İsim veya telefon ara..."
          className="w-full bg-white/[0.04] border border-white/[0.08] rounded-lg pl-9 pr-4 py-2.5 text-white text-sm placeholder:text-white/20 focus:outline-none focus:border-amber-500/50"
        />
      </div>

      <div className="rounded-xl bg-white/[0.03] border border-white/[0.07] overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-white/[0.06] bg-white/[0.02]">
                {['Ad Soyad', 'Telefon', 'Kaynak', 'Segment', 'İş Seviyesi', 'Tarih', ''].map((h) => (
                  <th key={h} className="text-left px-4 py-3 text-white/30 text-[11px] font-semibold uppercase tracking-wider">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredLeads.map((lead) => {
                const isSent = sentIds.has(lead.id);
                return (
                  <tr key={lead.id} className="border-b border-white/[0.03] hover:bg-white/[0.02] transition-colors">
                    <td className="px-4 py-3 text-white font-medium">{lead.ad_soyad}</td>
                    <td className="px-4 py-3 text-white/50 text-xs font-mono">{lead.telefon}</td>
                    <td className="px-4 py-3">
                      <span
                        className="text-xs font-semibold px-2 py-0.5 rounded-full"
                        style={{
                          background: (sourceColors[lead.kaynak] || '#6b7280') + '22',
                          color: sourceColors[lead.kaynak] || '#6b7280',
                        }}
                      >
                        {lead.kaynak}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <span
                        className="text-xs font-semibold px-2 py-0.5 rounded-full"
                        style={{
                          background: (segmentColors[lead.segment_durum] || '#6b7280') + '22',
                          color: segmentColors[lead.segment_durum] || '#6b7280',
                        }}
                      >
                        {lead.segment_durum}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-white/50 text-xs">{lead.is_seviyesi}</td>
                    <td className="px-4 py-3 text-white/30 text-xs">
                      {new Date(lead.olusturma_tarihi).toLocaleDateString('tr-TR')}
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2 justify-end">
                        <button
                          onClick={() => sendInvite(lead)}
                          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all cursor-pointer whitespace-nowrap ${
                            isSent
                              ? 'bg-emerald-500/15 text-emerald-400'
                              : 'bg-[#25d366]/15 hover:bg-[#25d366]/25 text-[#25d366]'
                          }`}
                        >
                          <i className={`${isSent ? 'ri-check-line' : 'ri-whatsapp-line'} text-xs`} />
                          {isSent ? 'Gönderildi' : 'Davet Gönder'}
                        </button>
                        <button
                          onClick={() => onViewDetail(lead)}
                          className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/[0.05] hover:bg-amber-500/15 text-white/30 hover:text-amber-400 transition-all cursor-pointer"
                        >
                          <i className="ri-eye-line text-sm" />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}